import "@fontsource/source-sans-pro/300.css";
import "@fontsource/source-sans-pro/400.css";
import "@fontsource/source-sans-pro/600.css";
import "@fontsource/source-sans-pro/700.css";
import "@fontsource/source-sans-pro/400-italic.css";
import { getAtlasComponents } from "./getAtlasComponents.js";
import { getAtlasPresets } from "./getAtlasPresets.js";
import { createPaletteOptions } from "./styles/palette.js";
import { createShadows } from "./styles/shadows.js";
import { createTypographyOptions } from "./styles/typography.js";
export const getAtlasThemeOptions = (tokens) => {
    return {
        atlasThemeName: "atlas",
        palette: createPaletteOptions(tokens),
        typography: createTypographyOptions(tokens),
        shadows: createShadows(tokens),
        presets: getAtlasPresets(tokens),
        components: getAtlasComponents(tokens),
        tokens,
    };
};
//# sourceMappingURL=getAtlasThemeOptions.js.map